export default {
  en: {
    title: 'F.A.Q.'
  },
  nl: {
    title: 'Veelgestelde vragen'
  }
}
